module.exports = __webpack_public_path__ + "static/media/refundSpecial.08c0cfdc.png";